import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PIcon, PText } from '@porsche-design-system/components-react';

import { Tooltip } from './Tooltip';

const Wrapper = styled('div', {
  base: {
    paddingBottom: 'xs',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'sm',
  },
  variants: {
    isDisabled: {
      true: {
        opacity: 0.4,
      },
    },
  },
});

export const Label = ({
  label,
  isRequired,
  isDisabled,
  tooltip,
}: {
  label?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
}) => {
  if (!label) return null;

  return (
    <Wrapper isDisabled={isDisabled}>
      <PText color="primary">
        {label}
        {`${isRequired ? ' *' : ''}`}
      </PText>
      {tooltip && (
        <Tooltip content={<PText size="xs">{tooltip}</PText>}>
          <PIcon name="information" />
        </Tooltip>
      )}
    </Wrapper>
  );
};
